import React, { useEffect, useState } from "react";
import Sidebar from "../EcomSellerDashboard";
import divider from "../../../../images/Vector.svg";
import notification from "../../../../images/Group 4572 (1).svg";
import currency from "../../../../images/currency wiith black.svg";
import arrow from "../../../../images/arrow-up.svg";
import order from "../../../../images/Vector1.svg";
import sold from "../../../../images/checkroom_black_24dp 1.svg";
import "./overview.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import SellerNavigationComponent from "./SellerNavigationComponent";
const baseUrl = process.env.REACT_APP_BASEURL;
const Overview = () => {
  const [details, setDetails] = useState("");
  const state = useSelector((state) => state.sellers);
  const { sellerAuth} = state;

  useEffect(() => {
  const seller=  localStorage.getItem("sellerregisterInfo");
  const sellerInfoObject = JSON.parse(seller);
  console.log(sellerInfoObject?._id); // Check the entire object

  const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller: sellerInfoObject?._id,
        }
      );
      setDetails(response.data);
      console.log(response.data,'response.data');
    };
    fetchDetails();
  }, []);
  return (
    <div>
      <div style={{ display: "flex" }}>
        <SellerNavigationComponent />
        <div style={{ display: "flex" }}>
          {/* <img src={divider} className="divider" /> */}
          <div>
            <p className="welcometext">Welcome, {details[0]?.Fullname}</p>
            <p className="todaysdate">Tue, 27 June 2023</p>
            <div style={{ display: "flex" }}>
              <div className="revenewmaindiv">
                <div className="currencydiv">
                  <div style={{ display: "flex" }}>
                    <img src={currency} className="currencyimage" />
                    <p className="revenuetext">Revenue</p>
                  </div>
                  <div style={{ display: "flex" }}>
                    <p className="revenueamount">₹0</p>
                    <img src={arrow} className="revenuearrow" />
                    <p className="revenuepercentage">+3%</p>
                  </div>
                </div>
              </div>
              <div className="totalordersmaindiv">
                <div style={{ display: "flex" }}>
                  <div className="orderimagediv">
                    <img src={order} className="ordermainimage" />
                  </div>
                  <p className="totalorderstext">Total orders</p>
                </div>
                <div style={{ display: "flex" }}>
                  <p className="ordernumber">0</p>
                  <img src={arrow} className="revenuearrow" />
                  <p className="revenuepercentage">+3%</p>
                </div>
              </div>
              <div className="totalordersmaindiv">
                <div style={{ display: "flex" }}>
                  <div className="orderimagediv">
                    <img src={sold} className="ordermainimage" />
                  </div>
                  <p className="totalorderstext">Product Sold</p>
                </div>
                <div style={{ display: "flex" }}>
                  <p className="ordernumber">0</p> 
                  <img src={arrow} className="revenuearrow" />
                  <p className="revenuepercentage">+3%</p>
                </div>
              </div>
            </div>
            <div className="topproductsdiv">
                <p className="topproductstext">All Products</p>
            </div>
          </div>
          {/* <div>
          <p className="todaysdate">Tue, 27 June 2023</p>
          <div className="revenewmaindiv">

          </div>
        </div> */}
          <div className="searchingmaindiv">
            <input placeholder="Search" className="searchinginputmaindiv" />
          </div>
          <div className="notificationmaindiv">
            <img src={notification} className="notificationimage" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
